import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import 'jquery-mask-plugin';
import './currency-mask';
import './input-masks';
import './autocomplete-cep';
import './billing-autocomplete-cep';

// ✅ Importa a função do websocket
import setupWebSocket from './websocket';

// ✅ Verifica se tem usuário logado
// const userId = window.Laravel?.userId;

// if (userId) {
//   setupWebSocket(userId);
// } else {
//   console.log('⚠️ Nenhum usuário autenticado encontrado.');
// }

document.addEventListener('livewire:init', () => {
    window.Livewire.on('websocket:init', (userId) => {
        console.log('🧩 Evento recebido websocket:init', userId);
        setupWebSocket(userId);
    });
});